import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CommentCard from "./CommentCard";
import { CardCol, CardRow, Container } from "./ProfileCard.style";
import UserCard from "./UserCard";
import UserReportCard from "./UserReportCard";
var ProfileCard = function (_a) {
    var recordData = _a.recordData, t = _a.t, onClickTransactionBtn = _a.onClickTransactionBtn;
    return (_jsx(Container, { children: _jsxs(CardRow, { children: [_jsxs(CardCol, { children: [_jsx(UserCard, { recordData: recordData, t: t, onClickTransactionBtn: onClickTransactionBtn }), _jsx(CommentCard, { recordData: recordData, t: t })] }), _jsx(UserReportCard, { recordData: recordData, t: t })] }) }));
};
export default ProfileCard;
